import React from "react";
import logo from "../../img/gamatotologo.png";
import { Link } from "react-router-dom";

export default () => {
  return (
    <div className="logo">
      <Link to="/kr">
        <img
          src={logo}
          alt="battlecatslogo"
          style={{
            height: "40px",
            float: "left",
            margin: "4px 8px 0px 10px",
          }}
          href="/kr"
        />
      </Link>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components-kr/menu/Logo.js